import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TApiKey = components['schemas']['ApiKeyResDto'];
export type TApiKeyDraft = components['schemas']['CreateApiKeyReqDto'];
export type TApiKeyScope = NonNullable<TApiKeyDraft['scopes']>[number];

type TCreatedApiKey = components['schemas']['CreatedApiKeyResDto'];

export const listApiKeys = (): Promise<TApiKey[]> => unwrap(api.GET('/v1/api-keys'));

export const createApiKey = (body: TApiKeyDraft): Promise<TCreatedApiKey> =>
  unwrap(api.POST('/v1/api-keys', { body }));

type TRevokedAll = components['schemas']['RevokeAllApiKeysResDto'];

export const revokeAllApiKeys = (): Promise<TRevokedAll> =>
  unwrap(api.POST('/v1/api-keys/revoke-all'));

export const revokeApiKey = async (id: string): Promise<void> => {
  await unwrap(api.DELETE('/v1/api-keys/{id}', { params: { path: { id } } }));
};
